import React, { useState } from "react";
import { Palette, X, RotateCcw } from "lucide-react";
import "../CustomizationStyle.css";

const CustomizationSettings = ({ settings, onSave, onClose }) => {
  const [localSettings, setLocalSettings] = useState(settings);
  

  const defaultColors = {
    gradient1: "#667eea",
    gradient2: "#764ba2",
    gradient3: "#f093fb",
    font: "#00608D",
  };

  const handleColorChange = (key, value) => {
    setLocalSettings({
      ...localSettings,
      [key]: value,
    });
  };

  const handleReset = () => {
    setLocalSettings({
      gradient1: defaultColors.gradient1,
      gradient2: defaultColors.gradient2,
      gradient3: defaultColors.gradient3,
      font: defaultColors.font,
    });
    setImagePreview(null);
  };

  const handleSave = () => {
    onSave(localSettings);
    onClose();
  };

  return (
    <div className="customization-overlay">
      <div className="customization-modal">
        <div className="customization-header">
          <div className="header-title">
            <Palette size={24} />
            <h2>Customize Your App</h2>
          </div>
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="customization-content">
          {/* Background Gradient Section */}
          <section className="customization-section">
            <h3>Background Gradient</h3>
            <div className="color-pickers">
              <div className="color-picker-item">
                <label>Color 1</label>
                <div className="color-input-wrapper">
                  <input
                    type="color"
                    value={localSettings.gradient1}
                    onChange={(e) =>
                      handleColorChange("gradient1", e.target.value)
                    }
                  />
                  <span className="color-value">{localSettings.gradient1}</span>
                </div>
              </div>
              <div className="color-picker-item">
                <label>Color 2</label>
                <div className="color-input-wrapper">
                  <input
                    type="color"
                    value={localSettings.gradient2}
                    onChange={(e) =>
                      handleColorChange("gradient2", e.target.value)
                    }
                  />
                  <span className="color-value">{localSettings.gradient2}</span>
                </div>
              </div>
              <div className="color-picker-item">
                <label>Color 3</label>
                <div className="color-input-wrapper">
                  <input
                    type="color"
                    value={localSettings.gradient3}
                    onChange={(e) =>
                      handleColorChange("gradient3", e.target.value)
                    }
                  />
                  <span className="color-value">{localSettings.gradient3}</span>
                </div>
              </div>
            </div>

            {/* Gradient Preview */}
            <div className="gradient-preview">
              <div
                className="preview-box"
                style={{
                  background: `linear-gradient(135deg, ${localSettings.gradient1} 0%, ${localSettings.gradient2} 50%, ${localSettings.gradient3} 100%)`,
                }}
              >
                <span>Preview</span>
              </div>
            </div>
          </section>

          <div className="font-color">
            <div className="color-pickers">
              <div className="color-picker-item">
                <label>Font Color</label>
                <div className="color-input-wrapper">
                  <input
                    type="color"
                    value={localSettings.font}
                    onChange={(e) => handleColorChange("font", e.target.value)}
                  />
                  <span className="color-value">{localSettings.font}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="customization-footer">
          <button className="reset-btn" onClick={handleReset}>
            <RotateCcw size={16} />
            Reset to Default
          </button>
          <div className="action-buttons">
            <button className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
            <button className="save-btn" onClick={handleSave}>
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomizationSettings;
